export default __webpack_public_path__ + "static/media/jarabe.45896aac.png";